import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function SolidFoodForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [foodName, setFoodName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [reactions, setReactions] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!foodName || !quantity) return;

    onAdd({
      date: new Date(date).toISOString(),
      foodName: foodName,
      quantity: quantity,
      reactions: reactions || "None",
      notes: notes || "",
    });

    setDate(toDatetimeLocal());
    setFoodName("");
    setQuantity("");
    setReactions("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Food Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Sweet potato"
            value={foodName}
            onChange={(e) => setFoodName(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Qty</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 2 tbsp"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Reactions</label>
          <input
            type="text"
            className="form-control"
            placeholder="Optional"
            value={reactions}
            onChange={(e) => setReactions(e.target.value)}
          />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button type="submit" className="btn btn-primary w-100">
            Add
          </button>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-12">
          <textarea
            className="form-control form-control-sm"
            placeholder="Add a note..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={2}
            style={{ resize: "none" }}
          />
        </div>
      </div>
    </form>
  );
}
